import { CONTINUOUS_BLOCK } from '../../../types/BlockTypes';
export default function isContinuousBlock(editor) {
  return Object.keys(CONTINUOUS_BLOCK).includes(editor.value.document.getClosestBlock(editor.value.selection.start.key).type);
}